import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabListItem } from '../shared.interface';

@Component({
    selector: 'app-tab-panel',
    templateUrl: './tab-panel.component.html',
    styleUrls: ['./tab-panel.component.scss'],
})
export class TabPanelComponent implements OnInit {
    active = 0;
    @Input() tabList: TabListItem;
    @Input() buyerSellerText: Object;
    @Output() activeTab = new EventEmitter<string>();

    constructor() {}

    ngOnInit(): void {
      console.log(this.buyerSellerText);
    }

    clickActiveTab(citizen) {
        this.activeTab.emit(citizen);
    }
}
